import isDev from './isDev';

const isWebManually = false;

export default isDev
  ? isWebManually
  : !!window.location.hostname && window.location.hostname !== 'localhost';
